import "core-js/modules/es.array.concat.js";
import { computed, defineComponent } from "vue"; // import { ArrowDown } from "@element-plus/icons-vue";
// modules

import UserModule from "@/store/modules/user";
export default defineComponent({
  name: "NavbarAvatar",
  components: {// ArrowDown,
  },
  props: {
    avatarWithLink: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup() {
    /* User data */
    var user = computed(function () {
      return UserModule.getUser || {};
    });
    var getInitials = computed(function () {
      var firstNameChar = user.value.firstName.charAt(0);
      var lastNameChar = user.value.lastName.charAt(0);
      return "".concat(firstNameChar.toUpperCase()).concat(lastNameChar.toUpperCase());
    });
    var getFullName = computed(function () {
      return " ".concat(user.value.fullname);
    });
    var getEmail = computed(function () {
      return user.value.emails[0].emailAddress;
    });
    /* UserGroups data */

    var userGroup = computed(function () {
      return UserModule.getUserSelectedGroupInfo;
    });
    var getRoleName = computed(function () {
      return userGroup.value.roleName;
    });
    return {
      getFullName: getFullName,
      getInitials: getInitials,
      getEmail: getEmail,
      getRoleName: getRoleName
    };
  }
});